import { KEYS_TAGS, IMAGE_HANDLING_CONTEXT } from '@components/imageHandling/common';
import { useHandleImageNavigation } from '@v2/pages/common/hooks/useHandleImageNavigation';
import { isSomeLinkFavoriteForScope } from '@v2/components/imageHandling/helpers';

import type { ImageWrapperProps } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ImageWrapper';

export interface UseManageImageWrapperParams
  extends Pick<
    ImageWrapperProps,
    | 'index'
    | 'imageDocumentId'
    | 'isImageHandlingNavigation'
    | 'documentRetrieveId'
    | 'documentRetrieveKey'
    | 'onImagePress'
    | 'id'
    | 'links'
    | 'shouldDisplayFavorites'
  > {}

export const useManageImageWrapper = (params: UseManageImageWrapperParams) => {
  const {
    index,
    imageDocumentId,
    isImageHandlingNavigation,
    documentRetrieveId,
    documentRetrieveKey,
    onImagePress,
    id,
    links,
    shouldDisplayFavorites,
  } = params;

  const { handleImageNavigation } = useHandleImageNavigation();

  const isFavorite =
    !!shouldDisplayFavorites &&
    isSomeLinkFavoriteForScope({
      links,
      scopeId: documentRetrieveKey ? KEYS_TAGS[documentRetrieveKey as keyof typeof KEYS_TAGS] : undefined,
      scopeReferenceId: typeof documentRetrieveId === 'string' ? Number(documentRetrieveId) : documentRetrieveId,
    });

  const shouldKeepState = documentRetrieveKey !== 'Machine';

  const onPress = () => {
    if (onImagePress) {
      onImagePress(id);
      return;
    }

    if (isImageHandlingNavigation) {
      handleImageNavigation({
        [IMAGE_HANDLING_CONTEXT[documentRetrieveKey]]: documentRetrieveId,
        ...(imageDocumentId != null ? { documentId: imageDocumentId } : {}),
        ...(imageDocumentId == null ? { index } : {}),
        keepState: shouldKeepState,
        mode: 'picture',
      });
    }
  };

  return { isFavorite, onPress };
};
